import { Wording } from '@/types';

export const ASTROLOGY_WORDING_EE: Wording = {
  components_header_media_content: 'Helid',
  components_header_media_1: 'Meditatsioonid',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Juhendid',
  components_header_text2: 'Blogi',
  components_header_members: 'liikmed',
  hero_text: 'Avastage sees olevaid tähti',
  hero_button_text: 'Alusta siit',
  components_ressources_section_title: 'VAHENDID',
  components_ressources_subheader_text: 'Kõik tööriistad, mida vajate kosmilise ülevaate ja eneseavastamise jaoks',
  components_ressources_span_text: 'Laiendage oma sisemist universumit taskuhäälingusaadete ja artiklite kureeritud seguga. Ükskõik, kas otsite kosmilist taipamist, selgust või vaimset joondamist, aitavad meie ressursid teil astroloogiaga praktilisel ja tähendusrikkal viisil ühendust luua.',
  components_ressources_card_1_title: 'Sügavad sukeldumised',
  components_ressources_card_1_text: 'Sukelduge astroloogiat, tarot, kosmilisi arhetüüpe ja vaimset kasvu käsitlevate põhjalike taskuhäälingusaadete rikkalikku kogumisse, mis on loodud teie teadlikkuse suurendamiseks ja praktika süvendamiseks.',
  components_ressources_card_2_title: 'Star Insights',
  components_ressources_card_2_text: 'Astroloogilised näpunäited ja blogipostitused eneseteadlikkuseks ja hingeliseks kasvamiseks.',
  components_ressources_link: 'Uurige edasi',
  components_notes_and_google_title_1: 'Astroloogiline juhend',
  components_notes_and_google_title_2: 'Kosmiline rutiin',
  components_notes_and_google_title_3: 'Peegeldused',
  components_review_google_text: 'Arvustused',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Meie podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Veel episoode',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Artiklid ja ülevaated',
  text2_section_button_more: 'Laadige rohkem',
  components_text1_section_title: 'JUHENDID',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Kuva kõik juhendid',
  components_footer_text: 'Äratage oma sisemine kosmos: teie tee, teie tähed.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreerimisnumber',
  components_footer_legal: 'Juriidiline',
  components_footer_terms: 'Tingimused',
  components_footer_privacy: 'Privaatsuspoliitika',
  button_load_more: 'Laadige rohkem',
  page_media_1_content_hero_text: 'Podcasti episoodid',
  page_media_content_menu_foundations: 'Vundamendid',
  page_media_content_menu_spirituality: 'Vaimsus',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psühholoogia',
  page_media_content_menu_trends: 'Trendid',
  page_media_2_content_hero_text: 'Meedia 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Meie ajaveeb',
  page_text2_section_title: 'Blogi',
  page_text2_subheader_text: 'Artiklid ja ülevaated',
  enter_email_title: 'Jätkamiseks sisestage oma e-posti aadress',
  enter_email_placeholder_email: 'Meil',
  enter_email_button_enter: 'Sisestage',
  components_login_success_text: 'Sisselogimine õnnestus!',
  components_card_link_media_content: 'Kuulake kohe',
  components_card_link_text1_content: 'Vaata juhendit',
  components_card_link_text2_content: 'Vaata artiklit',
  france: 'Prantsusmaa',
  cyprus: 'Küpros',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditatsioon',
  page_media_content_menu_all: 'Kõik',
};